// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "shipbob_returns_ui_styles" + "." + "050c728a" + ".chunk.css";
};